import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  X, Upload, Plus, Trash2, Edit3, Save, Cancel, Eye, EyeOff, Sparkles,
  Star, StarOff, ChevronUp, ChevronDown, ArrowUp, ArrowDown, Zap, Calendar, CalendarDays,
  Building
} from "lucide-react";
import { useUser } from "../../Context/UserContext";

const EditEvents = ({ event, onClose, fetchEvents, newEvent = false }) => {
  const { userDetails } = useUser();
  // Date selection states for Indian tickets
  const [currentIndianDate, setCurrentIndianDate] = useState("");
  const [editingIndianCategoryForDates, setEditingIndianCategoryForDates] = useState(-1);
  const [currentIndianTicketBg, setCurrentIndianTicketBg] = useState(null);
  const [currentInternationalTicketBg, setCurrentInternationalTicketBg] = useState(null);
  const [editingIndianCategoryBg, setEditingIndianCategoryBg] = useState({});
  const [editingInternationalCategoryBg, setEditingInternationalCategoryBg] = useState({});
  // Date selection states for International tickets  
  const [currentInternationalDate, setCurrentInternationalDate] = useState("");
  const [editingInternationalCategoryForDates, setEditingInternationalCategoryForDates] = useState(-1);
  // Basic event fields
  const [eventName, setEventName] = useState(event?.eventName || "");
  const [address, setAddress] = useState(event?.address || "");
  const [startDate, setStartDate] = useState(
    event?.startDate ? new Date(event.startDate).toISOString().split("T")[0] : ""
  );
  const [endDate, setEndDate] = useState(
    event?.endDate ? new Date(event.endDate).toISOString().split("T")[0] : ""
  );
  const [photo, setPhoto] = useState(null);
  const [idcardimage, setIdCardImage] = useState(null);
  const [categories, setCategories] = useState(event?.categories || []);
  const [currentCouponSelectedCategories, setCurrentCouponSelectedCategories] = useState([]);
const [formHeader, setFormHeader] = useState(event?.formHeader || 'Registration Form');
const [formSubHeader, setFormSubHeader] = useState(event?.formSubHeader || 'Fill in your details to generate your ID card');
  // New highlight event field
  const [highlightEvent, setHighlightEvent] = useState(event?.highlightEvent || false);

  // Payment and integration fields
  const [isPaidEvent, setIsPaidEvent] = useState(event?.isPaidEvent || false);
  const [razorpaySecret, setRazorpaySecret] = useState(event?.razorpaySecret || "");
  const [razorpayKey, setRazorpayKey] = useState(event?.razorpayKey || "");
  const [whatsappApiKey, setWhatsappApiKey] = useState(event?.whatsappApiKey || "");

  // Coupon states
  const [coupons, setCoupons] = useState(event?.coupons || []);
  const [currentCouponName, setCurrentCouponName] = useState("");
  const [currentCouponValue, setCurrentCouponValue] = useState("");
  const [currentCouponType, setCurrentCouponType] = useState("percentage");
  const [currentCouponScope, setCurrentCouponScope] = useState("indian");

  // Indian ticket categories
  const [indianTicketCategories, setIndianTicketCategories] = useState(
    event?.regionPricings?.find((rp) => rp.region === "indian")?.categories || []
  );
  const [currentIndianTicketName, setCurrentIndianTicketName] = useState("");
  const [currentIndianTicketRegularPrice, setCurrentIndianTicketRegularPrice] = useState("");
  const [currentIndianTicketEarlyBirdPrice, setCurrentIndianTicketEarlyBirdPrice] = useState("");
  const [currentIndianTicketEffectiveDailyRate, setCurrentIndianTicketEffectiveDailyRate] = useState("");
  const [currentIndianTicketHighlight, setCurrentIndianTicketHighlight] = useState(false);

  // International ticket categories
  const [internationalTicketCategories, setInternationalTicketCategories] = useState(
    event?.regionPricings?.find((rp) => rp.region === "international")?.categories || []
  );
  const [currentInternationalTicketName, setCurrentInternationalTicketName] = useState("");
  const [currentInternationalTicketRegularPrice, setCurrentInternationalTicketRegularPrice] = useState("");
  const [currentInternationalTicketEarlyBirdPrice, setCurrentInternationalTicketEarlyBirdPrice] = useState("");
  const [currentInternationalTicketEffectiveDailyRate, setCurrentInternationalTicketEffectiveDailyRate] = useState("");
  const [currentInternationalTicketHighlight, setCurrentInternationalTicketHighlight] = useState(false);
const [qrCodeText, setQrCodeText] = useState(event?.qrCodeText || 'Show at the Venue');
  // Header description states
  const [showIndianHeaderForm, setShowIndianHeaderForm] = useState({});
  const [showInternationalHeaderForm, setShowInternationalHeaderForm] = useState({});
  const [currentIndianHeader, setCurrentIndianHeader] = useState("");
  const [currentIndianDescription, setCurrentIndianDescription] = useState("");
  const [currentInternationalHeader, setCurrentInternationalHeader] = useState("");
  const [currentInternationalDescription, setCurrentInternationalDescription] = useState("");

  // Editing states
  const [editingCategoryIndex, setEditingCategoryIndex] = useState(-1);
  const [editingCategoryType, setEditingCategoryType] = useState("");
  const [editingCategoryData, setEditingCategoryData] = useState({});

  // UI states
  const [isUpdating, setIsUpdating] = useState(false);
  const [currentCategory, setCurrentCategory] = useState("");

  // Add auto promo states
  const [autoPromoEnabled, setAutoPromoEnabled] = useState(event?.autoPromoSettings?.enabled || false);
  const [autoPromoMinQuantity, setAutoPromoMinQuantity] = useState(event?.autoPromoSettings?.minQuantity || 10);
  const [autoPromoDiscountPercentage, setAutoPromoDiscountPercentage] = useState(event?.autoPromoSettings?.discountPercentage || 10);

  const [currentCouponLimit, setCurrentCouponLimit] = useState('');
  // Add this state for password visibility toggle
  const [showPassword, setShowPassword] = useState(false);

  const [currentCouponApplyFromRegular, setCurrentCouponApplyFromRegular] = useState(false);
  const [amenities, setAmenities] = useState(
    event?.amenities ? Object.keys(event.amenities) : []
  );
   const [currentAmenity, setCurrentAmenity] = useState("");




    const addAmenity = (e) => {
    e.preventDefault();
    if (currentAmenity.trim()) {
      setAmenities([...amenities, currentAmenity.trim()]);
      setCurrentAmenity("");
    }
  };





  const removeAmenity = (index) => {
    setAmenities(amenities.filter((_, i) => i !== index));
  };



  // Add new Indian ticket category
  const addIndianTicketCategory = (e) => {
    e.preventDefault();
    if (currentIndianTicketName.trim() && currentIndianTicketRegularPrice) {
      const regularPrice = parseFloat(currentIndianTicketRegularPrice);
      const earlyBirdPrice = parseFloat(currentIndianTicketEarlyBirdPrice);
      const effectiveDailyRate = currentIndianTicketEffectiveDailyRate ? parseFloat(currentIndianTicketEffectiveDailyRate) : 0;
      const earlyBirdSavings = regularPrice - earlyBirdPrice;

      setIndianTicketCategories([
        ...indianTicketCategories,
        {
          name: currentIndianTicketName.trim(),
          price: regularPrice,
          regularPrice: regularPrice,
          earlyBirdPrice: earlyBirdPrice,
          effectiveDailyRate: effectiveDailyRate,
          earlyBirdSavings: earlyBirdSavings,
          showRegularPrice: true,
          showEarlyBirdPrice: true,
          showEffectiveDailyRate: effectiveDailyRate > 0,
          showEarlyBirdSavings: true,
          headerDescriptions: [],
          highlightTicket: currentIndianTicketHighlight,
          order: indianTicketCategories.length,
          backgroundImage: currentIndianTicketBg ? currentIndianTicketBg : null,
        },
      ]);
      console.log(currentIndianTicketBg);
      setCurrentIndianTicketName("");
      setCurrentIndianTicketRegularPrice("");
      setCurrentIndianTicketEarlyBirdPrice("");
      setCurrentIndianTicketEffectiveDailyRate("");
      setCurrentIndianTicketHighlight(false);
      setCurrentIndianTicketBg(null);
    }
  };

  // Add new International ticket category
  const addInternationalTicketCategory = (e) => {
    e.preventDefault();
    if (currentInternationalTicketName.trim() && currentInternationalTicketRegularPrice) {
      const regularPrice = parseFloat(currentInternationalTicketRegularPrice);
      const earlyBirdPrice = parseFloat(currentInternationalTicketEarlyBirdPrice);
      const effectiveDailyRate = currentInternationalTicketEffectiveDailyRate ? parseFloat(currentInternationalTicketEffectiveDailyRate) : 0;
      const earlyBirdSavings = regularPrice - earlyBirdPrice;

      setInternationalTicketCategories([
        ...internationalTicketCategories,
        {
          name: currentInternationalTicketName.trim(),
          price: regularPrice,
          regularPrice: regularPrice,
          earlyBirdPrice: earlyBirdPrice,
          effectiveDailyRate: effectiveDailyRate,
          earlyBirdSavings: earlyBirdSavings,
          showRegularPrice: true,
          showEarlyBirdPrice: true,
          showEffectiveDailyRate: effectiveDailyRate > 0,
          showEarlyBirdSavings: true,
          headerDescriptions: [],
          highlightTicket: currentInternationalTicketHighlight,
          order: internationalTicketCategories.length,
          backgroundImage: currentInternationalTicketBg ? currentInternationalTicketBg : null,
        },
      ]);
      setCurrentInternationalTicketName("");
      setCurrentInternationalTicketRegularPrice("");
      setCurrentInternationalTicketEarlyBirdPrice("");
      setCurrentInternationalTicketEffectiveDailyRate("");
      setCurrentInternationalTicketHighlight(false);
      setCurrentInternationalTicketBg(null);
    }
  };

  // Remove ticket category
  const removeTicketCategory = (index, type) => {
    if (type === 'indian') {
      const newCategories = indianTicketCategories.filter((_, i) => i !== index);
      // Reorder remaining items
      newCategories.forEach((cat, idx) => {
        cat.order = idx;
      });
      setIndianTicketCategories(newCategories);
    } else {
      const newCategories = internationalTicketCategories.filter((_, i) => i !== index);
      // Reorder remaining items
      newCategories.forEach((cat, idx) => {
        cat.order = idx;
      });
      setInternationalTicketCategories(newCategories);
    }
  };

  // Start editing category
  const startEditingCategory = (e, index, type) => {
    e.preventDefault();
    setEditingCategoryIndex(index);
    setEditingCategoryType(type);

    const categories = type === 'indian' ? indianTicketCategories : internationalTicketCategories;
    const category = categories[index];

    setEditingCategoryData({
      name: category.name,
      regularPrice: category.regularPrice || category.price,
      earlyBirdPrice: category.earlyBirdPrice || '',
      effectiveDailyRate: category.effectiveDailyRate || '',
      highlightTicket: category.highlightTicket || false,
    });
  };

  // Save edited category
  const saveEditedCategory = () => {
    const { name, regularPrice, earlyBirdPrice, effectiveDailyRate, highlightTicket } = editingCategoryData;

    if (!name.trim() || !regularPrice) {
      alert("Please fill required fields");
      return;
    }

    const updatedCategory = {
      name: name.trim(),
      price: parseFloat(regularPrice),
      regularPrice: parseFloat(regularPrice),
      earlyBirdPrice: earlyBirdPrice ? parseFloat(earlyBirdPrice) : 0,
      effectiveDailyRate: effectiveDailyRate ? parseFloat(effectiveDailyRate) : 0,
      earlyBirdSavings: earlyBirdPrice ? parseFloat(regularPrice) - parseFloat(earlyBirdPrice) : 0,
      showRegularPrice: true,
      showEarlyBirdPrice: true,
      showEffectiveDailyRate: effectiveDailyRate > 0,
      showEarlyBirdSavings: true,
      highlightTicket: highlightTicket || false,
      // Preserve existing background image and other fields
      backgroundImage: editingCategoryType === 'indian'
        ? indianTicketCategories[editingCategoryIndex].backgroundImage
        : internationalTicketCategories[editingCategoryIndex].backgroundImage,
      headerDescriptions: editingCategoryType === 'indian'
        ? indianTicketCategories[editingCategoryIndex].headerDescriptions || []
        : internationalTicketCategories[editingCategoryIndex].headerDescriptions || [],
      enableDateSelection: editingCategoryType === 'indian'
        ? indianTicketCategories[editingCategoryIndex].enableDateSelection || false
        : internationalTicketCategories[editingCategoryIndex].enableDateSelection || false,
      availableDates: editingCategoryType === 'indian'
        ? indianTicketCategories[editingCategoryIndex].availableDates || []
        : internationalTicketCategories[editingCategoryIndex].availableDates || [],
      minDateSelection: editingCategoryType === 'indian'
        ? indianTicketCategories[editingCategoryIndex].minDateSelection || 1
        : internationalTicketCategories[editingCategoryIndex].minDateSelection || 1,
      maxDateSelection: editingCategoryType === 'indian'
        ? indianTicketCategories[editingCategoryIndex].maxDateSelection || 1
        : internationalTicketCategories[editingCategoryIndex].maxDateSelection || 1,
      order: editingCategoryType === 'indian'
        ? indianTicketCategories[editingCategoryIndex].order || 0
        : internationalTicketCategories[editingCategoryIndex].order || 0,
    };

    if (editingCategoryType === 'indian') {
      const updatedCategories = [...indianTicketCategories];
      updatedCategories[editingCategoryIndex] = updatedCategory;
      setIndianTicketCategories(updatedCategories);
    } else {
      const updatedCategories = [...internationalTicketCategories];
      updatedCategories[editingCategoryIndex] = updatedCategory;
      setInternationalTicketCategories(updatedCategories);
    }

    setEditingCategoryIndex(-1);
    setEditingCategoryType('');
    setEditingCategoryData({});
  };

  // Cancel editing category
  const cancelEditingCategory = () => {
    setEditingCategoryIndex(-1);
    setEditingCategoryType('');
    setEditingCategoryData({});
  };

  // Add header description to category
  const addHeaderDescription = (e, categoryIndex, type) => {
    e.preventDefault();

    console.log('type:', type);
    const header = type === 'indian' ? currentIndianHeader : currentInternationalHeader;
    const description = type === 'indian' ? currentIndianDescription : currentInternationalDescription;

    if (!header.trim() && !description.trim()) return;

    if (type === 'indian') {
      // console.log("updatedCategories:", updatedCategories);
      const updatedCategories = [...indianTicketCategories];
      if (!updatedCategories[categoryIndex].headerDescriptions) {
        updatedCategories[categoryIndex].headerDescriptions = [];
      }
      updatedCategories[categoryIndex].headerDescriptions.push({
        header: header.trim(),
        description: description.trim()
      });
      setIndianTicketCategories(updatedCategories);
      setCurrentIndianHeader("");
      setCurrentIndianDescription("");
      setShowIndianHeaderForm({ ...showIndianHeaderForm, [categoryIndex]: false });
    } else {
      const updatedCategories = [...internationalTicketCategories];
      if (!updatedCategories[categoryIndex].headerDescriptions) {
        updatedCategories[categoryIndex].headerDescriptions = [];
      }
      updatedCategories[categoryIndex].headerDescriptions.push({
        header: header.trim(),
        description: description.trim()
      });
      setInternationalTicketCategories(updatedCategories);
      setCurrentInternationalHeader("");
      setCurrentInternationalDescription("");
      setShowInternationalHeaderForm({ ...showInternationalHeaderForm, [categoryIndex]: false });
    }
  };

  // Remove header description
  const removeHeaderDescription = (e, categoryIndex, descIndex, type) => {
    e.preventDefault();
    if (type === 'indian') {
      const updatedCategories = [...indianTicketCategories];
      updatedCategories[categoryIndex].headerDescriptions.splice(descIndex, 1);
      setIndianTicketCategories(updatedCategories);
    } else {
      const updatedCategories = [...internationalTicketCategories];
      updatedCategories[categoryIndex].headerDescriptions.splice(descIndex, 1);
      setInternationalTicketCategories(updatedCategories);
    }
  };

  // Add new category
  const addCategory = () => {
    if (currentCategory.trim()) {
      setCategories([...categories, currentCategory.trim()]);
      setCurrentCategory("");
    }
  };

  // Remove category
  const removeCategory = (index) => {
    setCategories(categories.filter((_, i) => i !== index));
  };

  // Add new coupon
  const addCoupon = (e) => {
    e.preventDefault();
    if (currentCouponName.trim() && currentCouponValue) {
      setCoupons([
        ...coupons,
        {
          name: currentCouponName.trim(),
          value: parseFloat(currentCouponValue),
          type: currentCouponType,
          scope: currentCouponScope,
          selectedCategoryTickets: currentCouponSelectedCategories,
          limit: currentCouponLimit ? parseInt(currentCouponLimit) : null,
          usedCount: 0,
          applyFromRegularPrice: currentCouponApplyFromRegular 
        }
      ]);

      // Reset form
      setCurrentCouponName('');
      setCurrentCouponValue('');
      setCurrentCouponType('percentage');
      setCurrentCouponScope('indian');
      setCurrentCouponSelectedCategories([]); 
      setCurrentCouponLimit('');
      setCurrentCouponApplyFromRegular(false); 
    }
  };

  // Remove coupon
  const removeCoupon = (index) => {
    setCoupons(coupons.filter((_, i) => i !== index));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsUpdating(true);
    if (!password || password.length < 6) {
      alert("Password must be at least 6 characters long");
      setIsUpdating(false);
      return;
    }
    let apiURL = ``;
    let method = ""
    if (newEvent) {
      apiURL = `${process.env.REACT_APP_API_URL}/api/events`;
      method = "post"
    }
    else {
      apiURL = `${process.env.REACT_APP_API_URL}/api/events/edit/${event._id}`;
      method = "patch"
    }
    try {
      const formData = new FormData();
      formData.append("eventName", eventName);
      formData.append("address", address);
      formData.append("startDate", startDate);
      formData.append("endDate", endDate);
      if (photo) formData.append("photo", photo);
      if (idcardimage) formData.append("idcardimage", idcardimage);
      formData.append("categories", JSON.stringify(categories));
      formData.append("isPaidEvent", JSON.stringify(isPaidEvent));
      formData.append("highlightEvent", JSON.stringify(highlightEvent));
      formData.append("razorpaySecret", razorpaySecret);
      formData.append("razorpayKey", razorpayKey);
      formData.append("whatsappApiKey", whatsappApiKey);
      formData.append("username", username);
      formData.append("password", password);
   formData.append('formHeader', formHeader || 'Registration Form');
        formData.append('formSubHeader', formSubHeader || 'Fill in your details to generate your ID card');
formData.append('qrCodeText', qrCodeText || 'Show at the Venue');
      // Add auto promo settings
      formData.append("autoPromoSettings", JSON.stringify({
        enabled: autoPromoEnabled,
        minQuantity: autoPromoMinQuantity,
        discountPercentage: autoPromoDiscountPercentage
      }));
      // Prepare region pricings
      const regionPricings = [];
      if (indianTicketCategories.length > 0) {
        regionPricings.push({
          region: "indian",
          categories: indianTicketCategories
        });
      }
      if (internationalTicketCategories.length > 0) {
        regionPricings.push({
          region: "international",
          categories: internationalTicketCategories
        });
      }
      formData.append("regionPricings", JSON.stringify(regionPricings));
      formData.append("coupons", JSON.stringify(coupons));
 const amenitiesObject = amenities.reduce((acc, amenity) => {
        acc[amenity] = false;
        return acc;
      }, {});
      formData.append("amenities", JSON.stringify(amenitiesObject));
      const response = await axios({
        method: method,
        url: apiURL,
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      console.log("Event updated successfully:", response.data);
      fetchEvents();
      onClose();
    } catch (error) {
      console.error("Error updating event:", error);
      alert("Failed to update event. Please try again.");
    } finally {
      setIsUpdating(false);
    }
  };

  // Add new order functions
  const moveTicketUp = (e, index, type) => {
    e.preventDefault();
    if (index === 0) return; // Can't move first item up

    if (type === 'indian') {
      const newCategories = [...indianTicketCategories];
      // Swap with previous item
      [newCategories[index - 1], newCategories[index]] = [newCategories[index], newCategories[index - 1]];
      // Update order values
      newCategories.forEach((cat, idx) => {
        cat.order = idx;
      });
      setIndianTicketCategories(newCategories);
    } else {
      const newCategories = [...internationalTicketCategories];
      // Swap with previous item
      [newCategories[index - 1], newCategories[index]] = [newCategories[index], newCategories[index - 1]];
      // Update order values
      newCategories.forEach((cat, idx) => {
        cat.order = idx;
      });
      setInternationalTicketCategories(newCategories);
    }
  };

  const moveTicketDown = (e, index, type) => {
    e.preventDefault();
    const categories = type === 'indian' ? indianTicketCategories : internationalTicketCategories;
    if (index === categories.length - 1) return; // Can't move last item down

    if (type === 'indian') {
      const newCategories = [...indianTicketCategories];
      // Swap with next item
      [newCategories[index], newCategories[index + 1]] = [newCategories[index + 1], newCategories[index]];
      // Update order values
      newCategories.forEach((cat, idx) => {
        cat.order = idx;
      });
      setIndianTicketCategories(newCategories);
    } else {
      const newCategories = [...internationalTicketCategories];
      // Swap with next item
      [newCategories[index], newCategories[index + 1]] = [newCategories[index + 1], newCategories[index]];
      // Update order values
      newCategories.forEach((cat, idx) => {
        cat.order = idx;
      });
      setInternationalTicketCategories(newCategories);
    }
  };

  // Add date to Indian ticket category
  const addDateToIndianCategory = (e, categoryIndex) => {
    e.preventDefault();
    if (!currentIndianDate) return;

    const updatedCategories = [...indianTicketCategories];
    if (!updatedCategories[categoryIndex].availableDates) {
      updatedCategories[categoryIndex].availableDates = [];
    }

    const dateToAdd = new Date(currentIndianDate);
    // Check if date already exists
    const dateExists = updatedCategories[categoryIndex].availableDates.some(
      date => new Date(date).toDateString() === dateToAdd.toDateString()
    );

    if (!dateExists) {
      updatedCategories[categoryIndex].availableDates.push(dateToAdd);
      updatedCategories[categoryIndex].availableDates.sort((a, b) => new Date(a) - new Date(b));
    }

    setIndianTicketCategories(updatedCategories);
    setCurrentIndianDate("");
  };

  // Remove date from Indian ticket category
  const removeDateFromIndianCategory = (e, categoryIndex, dateIndex) => {
    e.preventDefault();
    const updatedCategories = [...indianTicketCategories];
    updatedCategories[categoryIndex].availableDates.splice(dateIndex, 1);
    setIndianTicketCategories(updatedCategories);
  };

  // Add date to International ticket category
  const addDateToInternationalCategory = (e, categoryIndex) => {
    e.preventDefault();
    if (!currentInternationalDate) return;

    const updatedCategories = [...internationalTicketCategories];
    if (!updatedCategories[categoryIndex].availableDates) {
      updatedCategories[categoryIndex].availableDates = [];
    }

    const dateToAdd = new Date(currentInternationalDate);
    // Check if date already exists
    const dateExists = updatedCategories[categoryIndex].availableDates.some(
      date => new Date(date).toDateString() === dateToAdd.toDateString()
    );

    if (!dateExists) {
      updatedCategories[categoryIndex].availableDates.push(dateToAdd);
      updatedCategories[categoryIndex].availableDates.sort((a, b) => new Date(a) - new Date(b));
    }

    setInternationalTicketCategories(updatedCategories);
    setCurrentInternationalDate("");
  };

  // Remove date from International ticket category
  const removeDateFromInternationalCategory = (e, categoryIndex, dateIndex) => {
    e.preventDefault();
    const updatedCategories = [...internationalTicketCategories];
    updatedCategories[categoryIndex].availableDates.splice(dateIndex, 1);
    setInternationalTicketCategories(updatedCategories);
  };

  // Toggle date selection for Indian category
  const toggleIndianDateSelection = (categoryIndex) => {
    const updatedCategories = [...indianTicketCategories];
    updatedCategories[categoryIndex].enableDateSelection = !updatedCategories[categoryIndex].enableDateSelection;

    // Initialize date fields if enabling
    if (updatedCategories[categoryIndex].enableDateSelection) {
      updatedCategories[categoryIndex].availableDates = updatedCategories[categoryIndex].availableDates || [];
      updatedCategories[categoryIndex].maxDateSelection = updatedCategories[categoryIndex].maxDateSelection || 1;
      updatedCategories[categoryIndex].minDateSelection = updatedCategories[categoryIndex].minDateSelection || 1;
    }

    setIndianTicketCategories(updatedCategories);
  };

  // Toggle date selection for International category
  const toggleInternationalDateSelection = (categoryIndex) => {
    const updatedCategories = [...internationalTicketCategories];
    updatedCategories[categoryIndex].enableDateSelection = !updatedCategories[categoryIndex].enableDateSelection;

    // Initialize date fields if enabling
    if (updatedCategories[categoryIndex].enableDateSelection) {
      updatedCategories[categoryIndex].availableDates = updatedCategories[categoryIndex].availableDates || [];
      updatedCategories[categoryIndex].maxDateSelection = updatedCategories[categoryIndex].maxDateSelection || 1;
      updatedCategories[categoryIndex].minDateSelection = updatedCategories[categoryIndex].minDateSelection || 1;
    }

    setInternationalTicketCategories(updatedCategories);
  };

  // Update date selection limits for Indian category
  const updateIndianDateLimits = (categoryIndex, field, value) => {
    const updatedCategories = [...indianTicketCategories];
    updatedCategories[categoryIndex][field] = parseInt(value) || 1;
    setIndianTicketCategories(updatedCategories);
  };

  // Update date selection limits for International category
  const updateInternationalDateLimits = (categoryIndex, field, value) => {
    const updatedCategories = [...internationalTicketCategories];
    updatedCategories[categoryIndex][field] = parseInt(value) || 1;
    setInternationalTicketCategories(updatedCategories);
  };

  // Format date for display
  const formatDateForDisplay = (date) => {
    return new Date(date).toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  };

  const renderIndianCategoryWithDates = (tc, i) => (
    <div key={i} className="border border-orange-200 rounded-lg p-3 bg-white/50">
      {/* Existing category content */}
      <div className="flex items-center justify-between mb-2">
        {editingCategoryIndex === i && editingCategoryType === 'indian' ? (
          // Edit Mode
          <div className="grid grid-cols-1 md:grid-cols-5 gap-3">
            <input
              type="text"
              value={editingCategoryData.name || ''}
              onChange={(e) => setEditingCategoryData({ ...editingCategoryData, name: e.target.value })}
              className="h-8 px-2 border-2 border-orange-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 text-sm"
              placeholder="Category Name"
            />
            <input
              type="number"
              value={editingCategoryData.regularPrice || ''}
              onChange={(e) => setEditingCategoryData({ ...editingCategoryData, regularPrice: e.target.value })}
              className="h-8 px-2 border-2 border-orange-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 text-sm"
              placeholder="Regular Price"
            />
            <input
              type="number"
              value={editingCategoryData.earlyBirdPrice || ''}
              onChange={(e) => setEditingCategoryData({ ...editingCategoryData, earlyBirdPrice: e.target.value })}
              className="h-8 px-2 border-2 border-orange-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 text-sm"
              placeholder="Early Bird Price"
            />
            <input
              type="number"
              value={editingCategoryData.effectiveDailyRate || ''}
              onChange={(e) => setEditingCategoryData({ ...editingCategoryData, effectiveDailyRate: e.target.value })}
              className="h-8 px-2 border-2 border-orange-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 text-sm"
              placeholder="Daily Rate"
            />

            {/* Background Image Upload in Edit Mode */}
            <div className="relative">
              <input
                type="file"
                accept="image/*"
                onChange={(e) => handleIndianBgUpload(e.target.files[0], i)}
                className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
              />
              <div className="h-8 px-2 border-2 border-orange-300 rounded-md bg-orange-50 flex items-center justify-center text-xs text-orange-700 hover:bg-orange-100 cursor-pointer">
                {tc.backgroundImage ? '✓ BG' : '+ BG'}
              </div>
              {tc.backgroundImage && (
                <div className="absolute -bottom-8 left-0 z-10">
                  <img
                    src={tc.backgroundImage}
                    alt="Preview"
                    className="w-12 h-8 object-cover rounded border border-orange-300"
                  />
                </div>
              )}
            </div>

            <div className="md:col-span-5 flex items-center justify-center bg-yellow-50 border border-yellow-200 rounded-md px-2">
              <label className="inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={editingCategoryData.highlightTicket || false}
                  onChange={(e) => setEditingCategoryData({ ...editingCategoryData, highlightTicket: e.target.checked })}
                  className="h-3 w-3 text-yellow-600 border-gray-300 rounded focus:ring-yellow-500"
                />
                <span className="ml-1 text-xs text-yellow-700 font-medium">⭐ Highlight Ticket</span>
              </label>
            </div>
            <div className="md:col-span-5 flex gap-2">
              <button onClick={saveEditedCategory} className="flex-1 py-1 bg-green-500 text-white rounded text-sm">
                <Save className="w-3 h-3 inline mr-1" /> Save
              </button>
              <button onClick={cancelEditingCategory} className="flex-1 py-1 bg-gray-500 text-white rounded text-sm">
                <X className="w-3 h-3 inline mr-1" /> Cancel
              </button>
            </div>
          </div>
        ) : (
          // View Mode
          <div>
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center space-x-2 mb-1">
                <h5 className="font-semibold text-gray-800 text-sm">{tc.name}</h5>
                {tc.highlightTicket && (
                  <div className="bg-yellow-100 text-yellow-800 px-2 py-0.5 rounded-full text-xs font-bold flex items-center space-x-1 animate-pulse">
                    <Sparkles className="w-3 h-3" />
                    <span>Featured</span>
                  </div>
                )}
                {tc.backgroundImage && (
                  <div className="bg-orange-100 text-orange-800 px-2 py-0.5 rounded-full text-xs font-bold flex items-center space-x-1">
                    <Upload className="w-3 h-3" />
                    <span>Custom BG</span>
                  </div>
                )}
              </div>
              <div className="flex items-center space-x-1">
                <div className="flex flex-col">
                  <button
                    onClick={(e) => moveTicketUp(e, i, 'indian')}
                    disabled={i === 0}
                    className={`p-1 text-xs ${i === 0 ? 'text-gray-300 cursor-not-allowed' : 'text-gray-600 hover:text-gray-800'}`}
                    title="Move up"
                  >
                    <ArrowUp className="w-3 h-3" />
                  </button>
                  <button
                    onClick={(e) => moveTicketDown(e, i, 'indian')}
                    disabled={i === indianTicketCategories.length - 1}
                    className={`p-1 text-xs ${i === indianTicketCategories.length - 1 ? 'text-gray-300 cursor-not-allowed' : 'text-gray-600 hover:text-gray-800'}`}
                    title="Move down"
                  >
                    <ArrowDown className="w-3 h-3" />
                  </button>
                </div>

                {/* Order Number Display */}
                <div className="bg-gray-100 text-gray-600 px-2 py-1 rounded text-xs font-medium">
                  #{i + 1}
                </div>

                {/* Background Image Toggle */}
                {tc.backgroundImage ? (
                  <button
                    onClick={() => removeTicketBg(i, 'indian')}
                    className="p-1 text-red-600 hover:text-red-800 text-xs"
                    title="Remove background image"
                  >
                    <EyeOff className="w-4 h-4" />
                  </button>
                ) : (
                  <div className="relative">
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) => handleIndianBgUpload(e.target.files[0], i)}
                      className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                    />
                    <button className="p-1 text-orange-600 hover:text-orange-800 text-xs" title="Add background image">
                      <Upload className="w-4 h-4" />
                    </button>
                  </div>
                )}

                {/* Highlight Toggle Button */}
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    const updatedCategories = [...indianTicketCategories];
                    updatedCategories[i].highlightTicket = !updatedCategories[i].highlightTicket;
                    setIndianTicketCategories(updatedCategories);
                  }}
                  className={`p-1 text-xs ${tc.highlightTicket ? 'text-yellow-600 hover:text-yellow-800' : 'text-gray-400 hover:text-yellow-600'}`}
                  title="Toggle highlight"
                >
                  {tc.highlightTicket ? <Star className="w-4 h-4" /> : <StarOff className="w-4 h-4" />}
                </button>

                <div
                  onClick={() => setShowIndianHeaderForm({ ...showIndianHeaderForm, [i]: !showIndianHeaderForm[i] })}
                  className="p-1 text-orange-600 cursor-pointer hover:text-orange-800"
                  title="Add header description"
                >
                  <Plus className="w-4 h-4" />
                </div>
                <button onClick={(e) => startEditingCategory(e, i, 'indian')} className="p-1 text-blue-600 hover:text-blue-800">
                  <Edit3 className="w-4 h-4" />
                </button>
                <div onClick={() => removeTicketCategory(i, 'indian')} className="p-1 cursor-pointer text-red-600 hover:text-red-800">
                  <Trash2 className="w-4 h-4" />
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-2 text-xs">
              <span>Regular: ₹{tc.regularPrice}</span>
              <span>Early Bird: ₹{tc.earlyBirdPrice || 0}</span>
              <span>Daily: ₹{tc.effectiveDailyRate || 0}</span>
              <span>Savings: ₹{tc.earlyBirdSavings || 0}</span>
            </div>

            {/* Background Image Preview */}
            {tc.backgroundImage && (
              <div className="mt-2">
                <div className="text-xs text-gray-600 mb-1">Background Image:</div>
                <div className="relative inline-block">
                  <img
                    src={tc.backgroundImage}
                    alt="Category background"
                    className="w-24 h-16 object-cover rounded border border-orange-200"
                  />
                  <button
                    onClick={() => removeTicketBg(i, 'indian')}
                    className="absolute -top-1 -right-1 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs hover:bg-red-600"
                    title="Remove background"
                  >
                    <X className="w-3 h-3" />
                  </button>
                </div>
              </div>
            )}

            {/* Header Descriptions */}
            {tc.headerDescriptions && tc.headerDescriptions.length > 0 && (
              <div className="mt-2 space-y-1">
                {tc.headerDescriptions.map((hd, hdIndex) => (
                  <div key={hdIndex} className="bg-orange-50 p-2 rounded text-xs border-l-4 border-orange-300">
                    <div className="flex justify-between items-start">
                      <div>
                        <strong>{hd.header}:</strong> {hd.description}
                      </div>
                      <button
                        onClick={(e) => removeHeaderDescription(e, i, hdIndex, 'indian')}
                        className="text-red-500 hover:text-red-700 ml-2"
                      >
                        <X className="w-3 h-3" />
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {/* Add Header Description Form */}
            {showIndianHeaderForm[i] && (
              <div className="mt-3 p-3 bg-orange-50 rounded border">
                <div className="grid grid-cols-1 gap-2">
                  <input
                    type="text"
                    placeholder="Header"
                    value={currentIndianHeader}
                    onChange={(e) => setCurrentIndianHeader(e.target.value)}
                    className="h-8 px-2 border rounded text-sm"
                  />
                  <textarea
                    placeholder="Description"
                    value={currentIndianDescription}
                    onChange={(e) => setCurrentIndianDescription(e.target.value)}
                    className="h-16 px-2 py-1 border rounded text-sm resize-none"
                  />
                  <div className="flex gap-2">
                    <button
                      onClick={(e) => addHeaderDescription(e, i, 'indian')}
                      className="flex-1 py-1 bg-orange-500 text-white rounded text-sm"
                    >
                      Add
                    </button>
                    <div
                      onClick={() => setShowIndianHeaderForm({ ...showIndianHeaderForm, [i]: false })}
                      className="flex-1 cursor-pointer py-1 bg-gray-500 text-white rounded text-sm text-center"
                    >
                      Cancel
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Date Selection Toggle */}
      <div className="mt-3 p-3 bg-orange-25 border border-orange-100 rounded-lg">
        <div className="flex items-center justify-between mb-3">
          <label className="inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              checked={tc.enableDateSelection || false}
              onChange={() => toggleIndianDateSelection(i)}
              className="h-4 w-4 text-orange-600 border-gray-300 rounded focus:ring-orange-500"
            />
            <span className="ml-2 text-sm font-medium text-gray-700 flex items-center space-x-1">
              <Calendar className="w-4 h-4" />
              <span>Enable Date Selection</span>
            </span>
          </label>
        </div>

        {tc.enableDateSelection && (
          <div className="space-y-4">
            {/* Date Selection Limits */}
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">
                  Min Dates to Select
                </label>
                <input
                  type="number"
                  min="1"
                  value={tc.minDateSelection || 1}
                  onChange={(e) => updateIndianDateLimits(i, 'minDateSelection', e.target.value)}
                  className="w-full px-2 py-1 border border-gray-300 rounded text-sm"
                />
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">
                  Max Dates to Select
                </label>
                <input
                  type="number"
                  min="1"
                  value={tc.maxDateSelection || 1}
                  onChange={(e) => updateIndianDateLimits(i, 'maxDateSelection', e.target.value)}
                  className="w-full px-2 py-1 border border-gray-300 rounded text-sm"
                />
              </div>
            </div>

            {/* Add Date */}
            <div className="flex gap-2">
              <input
                type="date"
                value={currentIndianDate}
                onChange={(e) => setCurrentIndianDate(e.target.value)}
                className="flex-1 px-2 py-1 border border-gray-300 rounded text-sm"
              />
              <button
                onClick={(e) => addDateToIndianCategory(e, i)}
                className="px-3 py-1 bg-orange-500 text-white rounded text-sm hover:bg-orange-600"
              >
                Add Date
              </button>
            </div>

            {/* Available Dates */}
            {tc.availableDates && tc.availableDates.length > 0 && (
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-2">
                  Available Dates ({tc.availableDates.length})
                </label>
                <div className="flex flex-wrap gap-2">
                  {tc.availableDates.map((date, dateIndex) => (
                    <div
                      key={dateIndex}
                      className="bg-orange-100 text-orange-800 px-2 py-1 rounded text-xs flex items-center space-x-1"
                    >
                      <CalendarDays className="w-3 h-3" />
                      <span>{formatDateForDisplay(date)}</span>
                      <button
                        onClick={(e) => removeDateFromIndianCategory(e, i, dateIndex)}
                        className="text-orange-600 hover:text-orange-800"
                      >
                        <X className="w-3 h-3" />
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );


  // Similar function for International categories
  const renderInternationalCategoryWithDates = (tc, i) => (
    <div key={i} className="border border-blue-200 rounded-lg p-3 bg-white/50">
      {/* Existing category content */}
      <div className="flex items-center justify-between mb-2">
        {editingCategoryIndex === i && editingCategoryType === 'international' ? (
          // Edit Mode - Add background image option
          <div className="grid grid-cols-1 md:grid-cols-5 gap-3">
            <input
              type="text"
              value={editingCategoryData.name || ''}
              onChange={(e) => setEditingCategoryData({ ...editingCategoryData, name: e.target.value })}
              className="h-8 px-2 border-2 border-blue-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
              placeholder="Category Name"
            />
            <input
              type="number"
              value={editingCategoryData.regularPrice || ''}
              onChange={(e) => setEditingCategoryData({ ...editingCategoryData, regularPrice: e.target.value })}
              className="h-8 px-2 border-2 border-blue-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
              placeholder="Regular Price"
            />
            <input
              type="number"
              value={editingCategoryData.earlyBirdPrice || ''}
              onChange={(e) => setEditingCategoryData({ ...editingCategoryData, earlyBirdPrice: e.target.value })}
              className="h-8 px-2 border-2 border-blue-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
              placeholder="Early Bird Price"
            />
            <input
              type="number"
              value={editingCategoryData.effectiveDailyRate || ''}
              onChange={(e) => setEditingCategoryData({ ...editingCategoryData, effectiveDailyRate: e.target.value })}
              className="h-8 px-2 border-2 border-blue-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
              placeholder="Daily Rate"
            />

            {/* Background Image Upload in Edit Mode */}
            <div className="relative">
              <input
                type="file"
                accept="image/*"
                onChange={(e) => handleInternationalBgUpload(e.target.files[0], i)}
                className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
              />
              <div className="h-8 px-2 border-2 border-blue-300 rounded-md bg-blue-50 flex items-center justify-center text-xs text-blue-700 hover:bg-blue-100 cursor-pointer">
                {tc.backgroundImage ? '✓ BG' : '+ BG'}
              </div>
            </div>

            <div className="md:col-span-5 flex items-center justify-center bg-yellow-50 border border-yellow-200 rounded-md px-2">
              <label className="inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={editingCategoryData.highlightTicket || false}
                  onChange={(e) => setEditingCategoryData({ ...editingCategoryData, highlightTicket: e.target.checked })}
                  className="h-3 w-3 text-yellow-600 border-gray-300 rounded focus:ring-yellow-500"
                />
                <span className="ml-1 text-xs text-yellow-700 font-medium">⭐ Highlight Ticket</span>
              </label>
            </div>
            <div className="md:col-span-5 flex gap-2">
              <button onClick={saveEditedCategory} className="flex-1 py-1 bg-green-500 text-white rounded text-sm">
                <Save className="w-3 h-3 inline mr-1" /> Save
              </button>
              <button onClick={cancelEditingCategory} className="flex-1 py-1 bg-gray-500 text-white rounded text-sm">
                <X className="w-3 h-3 inline mr-1" /> Cancel
              </button>
            </div>
          </div>
        ) : (
          // View Mode - Show background image status
          <div>
            <div className="flex items-center justify-between mb-2">
              <div className="flex items-center space-x-2 mb-1">
                <h5 className="font-semibold text-gray-800 text-sm">{tc.name}</h5>
                {tc.highlightTicket && (
                  <div className="bg-yellow-100 text-yellow-800 px-2 py-0.5 rounded-full text-xs font-bold flex items-center space-x-1 animate-pulse">
                    <Sparkles className="w-3 h-3" />
                    <span>Featured</span>
                  </div>
                )}
                {tc.backgroundImage && (
                  <div className="bg-blue-100 text-blue-800 px-2 py-0.5 rounded-full text-xs font-bold flex items-center space-x-1">
                    <Upload className="w-3 h-3" />
                    <span>Custom BG</span>
                  </div>
                )}
              </div>
              <div className="flex items-center space-x-1">
                {/* Order Control Buttons */}
                <div className="flex flex-col">
                  <button
                    onClick={(e) => moveTicketUp(e, i, 'international')}
                    disabled={i === 0}
                    className={`p-1 text-xs ${i === 0 ? 'text-gray-300 cursor-not-allowed' : 'text-gray-600 hover:text-gray-800'}`}
                    title="Move up"
                  >
                    <ArrowUp className="w-3 h-3" />
                  </button>
                  <button
                    onClick={(e) => moveTicketDown(e, i, 'international')}
                    disabled={i === internationalTicketCategories.length - 1}
                    className={`p-1 text-xs ${i === internationalTicketCategories.length - 1 ? 'text-gray-300 cursor-not-allowed' : 'text-gray-600 hover:text-gray-800'}`}
                    title="Move down"
                  >
                    <ArrowDown className="w-3 h-3" />
                  </button>
                </div>

                {/* Order Number Display */}
                <div className="bg-gray-100 text-gray-600 px-2 py-1 rounded text-xs font-medium">
                  #{i + 1}
                </div>

                {/* Background Image Toggle */}
                {tc.backgroundImage ? (
                  <button
                    onClick={() => removeTicketBg(i, 'international')}
                    className="p-1 text-red-600 hover:text-red-800 text-xs"
                    title="Remove background image"
                  >
                    <EyeOff className="w-4 h-4" />
                  </button>
                ) : (
                  <div className="relative">
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) => handleInternationalBgUpload(e.target.files[0], i)}
                      className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                    />
                    <button className="p-1 text-blue-600 hover:text-blue-800 text-xs" title="Add background image">
                      <Upload className="w-4 h-4" />
                    </button>
                  </div>
                )}

                {/* Highlight Toggle Button */}
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    const updatedCategories = [...internationalTicketCategories];
                    updatedCategories[i].highlightTicket = !updatedCategories[i].highlightTicket;
                    setInternationalTicketCategories(updatedCategories);
                  }}
                  className={`p-1 text-xs ${tc.highlightTicket ? 'text-yellow-600 hover:text-yellow-800' : 'text-gray-400 hover:text-yellow-600'}`}
                  title="Toggle highlight"
                >
                  {tc.highlightTicket ? <Star className="w-4 h-4" /> : <StarOff className="w-4 h-4" />}
                </button>

                <div
                  onClick={() => setShowInternationalHeaderForm({ ...showInternationalHeaderForm, [i]: !showInternationalHeaderForm[i] })}
                  className="p-1 text-blue-600 hover:text-blue-800 cursor-pointer"
                  title="Add header description"
                >
                  <Plus className="w-4 h-4" />
                </div>
                <button onClick={(e) => startEditingCategory(e, i, 'international')} className="p-1 text-blue-600 hover:text-blue-800">
                  <Edit3 className="w-4 h-4" />
                </button>
                <div onClick={() => removeTicketCategory(i, 'international')} className="p-1 cursor-pointer text-red-600 hover:text-red-800">
                  <Trash2 className="w-4 h-4" />
                </div>
              </div>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-2 text-xs">
              <span>Regular: ${tc.regularPrice}</span>
              <span>Early Bird: ${tc.earlyBirdPrice || 0}</span>
              <span>Daily: ${tc.effectiveDailyRate || 0}</span>
              <span>Savings: ${tc.earlyBirdSavings || 0}</span>
            </div>

            {/* Background Image Preview */}
            {tc.backgroundImage && (
              <div className="mt-2">
                <div className="text-xs text-gray-600 mb-1">Background Image:</div>
                <img
                  src={tc.backgroundImage}
                  alt="Category background"
                  className="w-20 h-12 object-cover rounded border border-blue-200"
                />
              </div>
            )}

            {/* Header Descriptions */}
            {tc.headerDescriptions && tc.headerDescriptions.length > 0 && (
              <div className="mt-2 space-y-1">
                {tc.headerDescriptions.map((hd, hdIndex) => (
                  <div key={hdIndex} className="bg-blue-50 p-2 rounded text-xs border-l-4 border-blue-300">
                    <div className="flex justify-between items-start">
                      <div>
                        <strong>{hd.header}:</strong> {hd.description}
                      </div>
                      <button
                        onClick={(e) => removeHeaderDescription(e, i, hdIndex, 'international')}
                        className="text-red-500 hover:text-red-700 ml-2"
                      >
                        <X className="w-3 h-3" />
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {/* Add Header Description Form */}
            {showInternationalHeaderForm[i] && (
              <div className="mt-3 p-3 bg-blue-50 rounded border">
                <div className="grid grid-cols-1 gap-2">
                  <input
                    type="text"
                    placeholder="Header"
                    value={currentInternationalHeader}
                    onChange={(e) => setCurrentInternationalHeader(e.target.value)}
                    className="h-8 px-2 border rounded text-sm"
                  />
                  <textarea
                    placeholder="Description"
                    value={currentInternationalDescription}
                    onChange={(e) => setCurrentInternationalDescription(e.target.value)}
                    className="h-16 px-2 py-1 border rounded text-sm resize-none"
                  />
                  <div className="flex gap-2">
                    <button
                      onClick={(e) => addHeaderDescription(e, i, 'international')}
                      className="flex-1 py-1 bg-blue-500 text-white rounded text-sm"
                    >
                      Add
                    </button>
                    <button
                      onClick={() => setShowInternationalHeaderForm({ ...showInternationalHeaderForm, [i]: false })}
                      className="flex-1 py-1 bg-gray-500 text-white rounded text-sm"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Date Selection Toggle */}
      <div className="mt-3 p-3 bg-blue-25 border border-blue-100 rounded-lg">
        <div className="flex items-center justify-between mb-3">
          <label className="inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              checked={tc.enableDateSelection || false}
              onChange={() => toggleInternationalDateSelection(i)}
              className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
            />
            <span className="ml-2 text-sm font-medium text-gray-700 flex items-center space-x-1">
              <Calendar className="w-4 h-4" />
              <span>Enable Date Selection</span>
            </span>
          </label>
        </div>

        {tc.enableDateSelection && (
          <div className="space-y-4">
            {/* Date Selection Limits */}
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">
                  Min Dates to Select
                </label>
                <input
                  type="number"
                  min="1"
                  value={tc.minDateSelection || 1}
                  onChange={(e) => updateInternationalDateLimits(i, 'minDateSelection', e.target.value)}
                  className="w-full px-2 py-1 border border-gray-300 rounded text-sm"
                />
              </div>
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-1">
                  Max Dates to Select
                </label>
                <input
                  type="number"
                  min="1"
                  value={tc.maxDateSelection || 1}
                  onChange={(e) => updateInternationalDateLimits(i, 'maxDateSelection', e.target.value)}
                  className="w-full px-2 py-1 border border-gray-300 rounded text-sm"
                />
              </div>
            </div>

            {/* Add Date */}
            <div className="flex gap-2">
              <input
                type="date"
                value={currentInternationalDate}
                onChange={(e) => setCurrentInternationalDate(e.target.value)}
                className="flex-1 px-2 py-1 border border-gray-300 rounded text-sm"
              />
              <button
                onClick={(e) => addDateToInternationalCategory(e, i)}
                className="px-3 py-1 bg-blue-500 text-white rounded text-sm hover:bg-blue-600"
              >
                Add Date
              </button>
            </div>

            {/* Available Dates */}
            {tc.availableDates && tc.availableDates.length > 0 && (
              <div>
                <label className="block text-xs font-medium text-gray-700 mb-2">
                  Available Dates ({tc.availableDates.length})
                </label>
                <div className="flex flex-wrap gap-2">
                  {tc.availableDates.map((date, dateIndex) => (
                    <div
                      key={dateIndex}
                      className="bg-blue-100 text-blue-800 px-2 py-1 rounded text-xs flex items-center space-x-1"
                    >
                      <CalendarDays className="w-3 h-3" />
                      <span>{formatDateForDisplay(date)}</span>
                      <button
                        onClick={(e) => removeDateFromInternationalCategory(e, i, dateIndex)}
                        className="text-blue-600 hover:text-blue-800"
                      >
                        <X className="w-3 h-3" />
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );


  // Handle background image upload for Indian categories
  const handleIndianBgUpload = async (file, categoryIndex = null) => {
    if (!file) return;

    const formData = new FormData();
    formData.append('image', file);
    console.log(formData);
    console.log(file);
    try {
      // Replace with your actual upload endpoint
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/upload-image`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      const imageUrl = response.data.url;

      if (categoryIndex !== null) {
        // Update existing category
        const updatedCategories = [...indianTicketCategories];
        updatedCategories[categoryIndex].backgroundImage = imageUrl;
        setIndianTicketCategories(updatedCategories);
      } else {
        // For new category
        setCurrentIndianTicketBg(imageUrl);
      }
    } catch (error) {
      console.error('Error uploading image:', error);
      alert('Failed to upload image');
    }
  };


  // Handle background image upload for International categories
  const handleInternationalBgUpload = async (file, categoryIndex = null) => {
    if (!file) return;

    const formData = new FormData();
    formData.append('image', file);

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/upload-image`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      const imageUrl = response.data.url;

      if (categoryIndex !== null) {
        const updatedCategories = [...internationalTicketCategories];
        updatedCategories[categoryIndex].backgroundImage = imageUrl;
        setInternationalTicketCategories(updatedCategories);
      } else {
        setCurrentInternationalTicketBg(imageUrl);
      }
    } catch (error) {
      console.error('Error uploading image:', error);
      alert('Failed to upload image');
    }
  };
  // Remove background image
  const removeTicketBg = (categoryIndex, type) => {
    if (type === 'indian') {
      const updatedCategories = [...indianTicketCategories];
      updatedCategories[categoryIndex].backgroundImage = null;
      setIndianTicketCategories(updatedCategories);
    } else {
      const updatedCategories = [...internationalTicketCategories];
      updatedCategories[categoryIndex].backgroundImage = null;
      setInternationalTicketCategories(updatedCategories);
    }
  };

  const [username, setUsername] = useState(event?.username || "");
  const [password, setPassword] = useState(event?.password || "");

  const generateUsername = (eventName) => {
    if (!eventName.trim()) return "";

    // Clean the event name: remove special characters, convert to lowercase, replace spaces with underscores
    const cleanEventName = eventName
      .toLowerCase()
      .replace(/[^a-z0-9\s]/g, '')
      .replace(/\s+/g, '_')
      .substring(0, 9); // Limit to 15 characters

    // Generate a random suffix (4 digits)
    const randomSuffix = Math.floor(1000 + Math.random() * 9000);

    // Add current year for uniqueness
    const currentYear = new Date().getFullYear().toString().slice(-2);

    return `${cleanEventName}_${currentYear}_${randomSuffix}`;
  };

  useEffect(() => {
    if (eventName && (!event?.username || event?.username === "")) {
      const generatedUsername = generateUsername(eventName);
      setUsername(generatedUsername);
    }
  }, [eventName, event?.username]);


  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-2xl w-full max-w-6xl max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-white rounded-t-2xl border-b border-gray-200 px-6 py-4 z-10">
          <div className="flex items-center justify-between">
            <h2 className="text-2xl font-bold text-gray-800">
              {newEvent ? "Create New Event" : `Edit ${event?.eventName}`}
            </h2>
            <button
              onClick={onClose}
              className="p-2 hover:bg-gray-100 rounded-full transition-colors duration-200"
            >
              <X className="w-6 h-6 text-gray-600" />
            </button>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-6">
          {/* Basic Event Information */}
          <div className="bg-gradient-to-r from-blue-50 via-indigo-50 to-purple-50 rounded-xl p-6 border border-blue-200/50">
            <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center space-x-2">
              <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
              <span>Event Information</span>
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Event Name *
                </label>
                <input
                  type="text"
                  value={eventName}
                  onChange={(e) => setEventName(e.target.value)}
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200"
                  placeholder="Enter event name"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Address *
                </label>
                <input
                  type="text"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200"
                  placeholder="Enter event address"
                  required
                />
              </div>
              {/* New Username Field */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Username (Auto-generated)
                </label>
                <div className="relative">
                  <input
                    type="text"
                    value={username}
                    readOnly
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg bg-gray-50 text-gray-600 cursor-not-allowed"
                    placeholder="Auto-generated username"
                  />
                  <div className="absolute right-3 top-1/2 transform -translate-y-1/2 flex items-center space-x-2">
                    {event?.username && (
                      <div className="w-2 h-2 bg-blue-500 rounded-full" title="Existing username"></div>
                    )}
                    {!event?.username && (
                      <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse" title="Auto-generated"></div>
                    )}
                  </div>
                </div>
                <p className="text-xs text-gray-500 mt-1">
                  {event?.username
                    ? "This username was previously set and cannot be changed"
                    : "This username is automatically generated based on your event name"
                  }
                </p>
              </div>

              {/* New Password Field */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Password *
                </label>
                <div className="relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 pr-12"
                    placeholder="Enter password"
                    required
                    minLength="6"
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none"
                    title={showPassword ? "Hide password" : "Show password"}
                  >
                    {showPassword ? (
                      <EyeOff className="w-5 h-5" />
                    ) : (
                      <Eye className="w-5 h-5" />
                    )}
                  </button>
                </div>
                <p className="text-xs text-gray-500 mt-1">
                  Minimum 6 characters required • Click eye icon to toggle visibility
                </p>
              </div>
            </div>
          </div>
          {/* Form Header Customization Section */}
<div className="bg-gradient-to-r from-teal-50 via-cyan-50 to-sky-50 rounded-xl p-6 border border-teal-200/50">
    <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center space-x-2">
        <div className="w-2 h-2 bg-teal-500 rounded-full"></div>
        <span>Registration Form Headers</span>
    </h3>
    <p className="text-sm text-gray-600 mb-4">
        Customize the header text that appears on your registration form. Leave blank to use defaults.
    </p>
    
    <div className="grid grid-cols-1 gap-4">
        <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
                Form Header
            </label>
            <input
                type="text"
                value={formHeader}
                onChange={(e) => setFormHeader(e.target.value)}
                className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-teal-500 transition-all duration-200"
                placeholder="Registration Form"
            />
            <p className="text-xs text-gray-500 mt-1">
                Default: "Registration Form"
            </p>
        </div>
        
        <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
                Form Sub-Header
            </label>
            <textarea
                value={formSubHeader}
                onChange={(e) => setFormSubHeader(e.target.value)}
                className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-teal-500 transition-all duration-200 resize-none"
                rows="2"
                placeholder="Fill in your details to generate your ID card"
            />
            <p className="text-xs text-gray-500 mt-1">
                Default: "Fill in your details to generate your ID card"
            </p>
        </div>
    </div>
</div>
{/* QR Code Text Customization Section */}
<div className="bg-gradient-to-r from-indigo-50 via-blue-50 to-cyan-50 rounded-xl p-6 border border-indigo-200/50">
    <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center space-x-2">
        <div className="w-2 h-2 bg-indigo-500 rounded-full"></div>
        <span>QR Code Text</span>
    </h3>
    <p className="text-sm text-gray-600 mb-4">
        Customize the text that appears above the QR code on ID cards.
    </p>
    
    <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
            QR Code Label Text
        </label>
        <input
            type="text"
            value={qrCodeText}
            onChange={(e) => setQrCodeText(e.target.value)}
            className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-all duration-200"
            placeholder="Show at the Venue"
        />
        <p className="text-xs text-gray-500 mt-1">
            Default: "Show at the Venue"
        </p>
    </div>
</div>

          {/* Event Dates */}
          <div className="bg-gradient-to-r from-green-50 via-emerald-50 to-teal-50 rounded-xl p-6 border border-green-200/50">
            <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center space-x-2">
              <div className="w-2 h-2 bg-green-500 rounded-full"></div>
              <span>Event Dates</span>
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Start Date *
                </label>
                <input
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all duration-200"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  End Date *
                </label>
                <input
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all duration-200"
                  required
                />
              </div>
            </div>
          </div>

          {/* Event Features */}
          <div className="bg-gradient-to-r from-yellow-50 via-orange-50 to-red-50 rounded-xl p-6 border border-yellow-200/50">
            <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center space-x-2">
              <Sparkles className="w-5 h-5 text-yellow-600" />
              <span>Event Features</span>
            </h3>
            <div className="flex items-center space-x-6">
              <label className="inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={highlightEvent}
                  onChange={(e) => setHighlightEvent(e.target.checked)}
                  className="h-4 w-4 text-yellow-600 border-gray-300 rounded focus:ring-yellow-500"
                />
                <span className="ml-2 text-gray-800 font-medium text-sm flex items-center space-x-1">
                  <Sparkles className="w-3 h-3 text-yellow-500" />
                  <span>Highlight this event</span>
                </span>
              </label>
              {highlightEvent && (
                <div className="bg-yellow-100 text-yellow-800 px-3 py-1 rounded-full text-xs font-medium animate-pulse">
                  ⭐ Featured Event
                </div>
              )}
            </div>
            <p className="text-xs text-gray-600 mt-2">
              Highlighted events will appear prominently and be marked as featured
            </p>
          </div>

          {/* Image Uploads */}
          <div className="bg-gradient-to-r from-purple-50 via-pink-50 to-rose-50 rounded-xl p-6 border border-purple-200/50">
            <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center space-x-2">
              <Upload className="w-5 h-5 text-purple-600" />
              <span>Images</span>
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Event Photo
                </label>
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => setPhoto(e.target.files[0])}
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all duration-200"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  ID Card Background
                </label>
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => setIdCardImage(e.target.files[0])}
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all duration-200"
                />
              </div>
            </div>
          </div>

          {/* Categories */}
          <div className="bg-gradient-to-r from-cyan-50 via-blue-50 to-indigo-50 rounded-xl p-6 border border-cyan-200/50">
            <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center space-x-2">
              <div className="w-2 h-2 bg-cyan-500 rounded-full"></div>
              <span>Categories</span>
            </h3>
            <div className="flex flex-wrap gap-2 mb-4">
              {categories.map((category, index) => (
                <div
                  key={index}
                  className="bg-cyan-100 text-cyan-800 px-3 py-1 rounded-full text-sm flex items-center space-x-2"
                >
                  <span>{category}</span>
                  <button
                    type="button"
                    onClick={() => removeCategory(index)}
                    className="text-cyan-600 hover:text-cyan-800"
                  >
                    <X className="w-3 h-3" />
                  </button>
                </div>
              ))}
            </div>
            <div className="flex gap-2">
              <input
                type="text"
                value={currentCategory}
                onChange={(e) => setCurrentCategory(e.target.value)}
                className="flex-1 px-4 py-2 border-2 border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:border-cyan-500"
                placeholder="Add category"
              />
              <button
                type="button"
                onClick={addCategory}
                className="px-4 py-2 bg-cyan-500 text-white rounded-lg hover:bg-cyan-600 transition-colors duration-200"
              >
                <Plus className="w-4 h-4" />
              </button>
            </div>
          </div>

          {/* Amenities */}
            <div className="bg-gradient-to-r from-purple-50 via-violet-50 to-indigo-50 rounded-xl p-4 border border-purple-200/50">
                    <h3 className="text-base font-bold text-gray-800 mb-3 flex items-center space-x-2">
                      <Building className="w-4 h-4 text-purple-600" />
                      <span>Amenities</span>
                    </h3>
                    <div className="flex items-center space-x-2 mb-3">
                      <input
                        type="text"
                        value={currentAmenity}
                        onChange={(e) => setCurrentAmenity(e.target.value)}
                        className="flex-1 h-8 px-3 bg-white border-2 border-purple-200 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all duration-300 text-sm"
                        placeholder="Add Amenity"
                      />
                      <button
                        onClick={addAmenity}
                        className="group relative overflow-hidden bg-gradient-to-r from-purple-500 to-violet-600 hover:from-purple-400 hover:to-violet-500 text-white font-semibold py-1.5 px-3 rounded-md shadow-md hover:shadow-lg transform hover:scale-105 transition-all duration-300 text-sm"
                      >
                        Add
                      </button>
                    </div>
                    <div className="space-y-1.5 max-h-24 overflow-y-auto">
                      {amenities.map((amenity, index) => (
                        <div
                          key={index}
                          className="flex items-center justify-between bg-white p-2 rounded-md border border-purple-200/60 shadow-sm"
                        >
                          <span className="text-gray-700 font-medium text-sm">{amenity}</span>
                          <button
                            onClick={() => removeAmenity(index)}
                            className="p-0.5 bg-red-100 hover:bg-red-200 text-red-600 rounded-sm transition-all duration-300"
                          >
                            <X className="w-3 h-3" />
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>

          {/* Payment Configuration */}
          <div className="bg-gradient-to-r from-emerald-50 via-teal-50 to-cyan-50 rounded-xl p-6 border border-emerald-200/50">
            <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center space-x-2">
              <div className="w-2 h-2 bg-emerald-500 rounded-full"></div>
              <span>Payment Configuration</span>
            </h3>
            {!userDetails.type && <div className="mb-4">
              <label className="inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  checked={isPaidEvent}
                  onChange={(e) => setIsPaidEvent(e.target.checked)}
                  className="h-4 w-4 text-emerald-600 border-gray-300 rounded focus:ring-emerald-500"
                />
                <span className="ml-2 text-gray-800 font-medium">This is a paid event</span>
              </label>
            </div>}
            {isPaidEvent && (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Razorpay Key
                  </label>
                  <input
                    type="text"
                    value={razorpayKey}
                    onChange={(e) => setRazorpayKey(e.target.value)}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
                    placeholder="Enter Razorpay key"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Razorpay Secret
                  </label>
                  <input
                    type="text"
                    value={razorpaySecret}
                    onChange={(e) => setRazorpaySecret(e.target.value)}
                    className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500"
                    placeholder="Enter Razorpay secret"
                  />
                </div>
              </div>
            )}
          </div>

          {/* WhatsApp Integration */}
          <div className="bg-gradient-to-r from-green-50 via-lime-50 to-emerald-50 rounded-xl p-6 border border-green-200/50">
            <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center space-x-2">
              <div className="w-2 h-2 bg-green-500 rounded-full"></div>
              <span>WhatsApp Integration</span>
            </h3>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                WhatsApp API Key
              </label>
              <input
                type="text"
                value={whatsappApiKey}
                onChange={(e) => setWhatsappApiKey(e.target.value)}
                className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500"
                placeholder="Enter WhatsApp API key"
              />
            </div>
          </div>

          {/* Auto Promotional Settings - Add this new section */}
          <div className="bg-gradient-to-r from-purple-50 via-violet-50 to-indigo-50 rounded-xl p-6 border border-purple-200/50">
            <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center space-x-2">
              <Zap className="w-5 h-5 text-purple-600" />
              <span>Auto Promotional Discount</span>
            </h3>

            <div className="space-y-4">
              {/* Enable Auto Promo */}
              <div className="flex items-center space-x-6">
                <label className="inline-flex items-center cursor-pointer">
                  <input
                    type="checkbox"
                    checked={autoPromoEnabled}
                    onChange={(e) => setAutoPromoEnabled(e.target.checked)}
                    className="h-4 w-4 text-purple-600 border-gray-300 rounded focus:ring-purple-500"
                  />
                  <span className="ml-2 text-gray-800 font-medium text-sm flex items-center space-x-1">
                    <Zap className="w-3 h-3 text-purple-500" />
                    <span>Enable automatic bulk discount</span>
                  </span>
                </label>
                {autoPromoEnabled && (
                  <div className="bg-purple-100 text-purple-800 px-3 py-1 rounded-full text-xs font-medium animate-pulse">
                    🎯 Auto Discount Active
                  </div>
                )}
              </div>

              {autoPromoEnabled && (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-4 bg-white/50 rounded-lg border border-purple-200">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Minimum Quantity (Same Category)
                    </label>
                    <input
                      type="number"
                      min="2"
                      max="100"
                      value={autoPromoMinQuantity}
                      onChange={(e) => setAutoPromoMinQuantity(parseInt(e.target.value) || 10)}
                      className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
                      placeholder="10"
                    />
                    <p className="text-xs text-gray-600 mt-1">
                      Minimum tickets in the same category to trigger discount
                    </p>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Discount Percentage
                    </label>
                    <input
                      type="number"
                      min="1"
                      max="50"
                      value={autoPromoDiscountPercentage}
                      onChange={(e) => setAutoPromoDiscountPercentage(parseInt(e.target.value) || 10)}
                      className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
                      placeholder="10"
                    />
                    <p className="text-xs text-gray-600 mt-1">
                      Percentage discount to apply (1-50%)
                    </p>
                  </div>
                </div>
              )}

              <div className="bg-blue-50 border border-blue-200 rounded-lg p-3">
                <p className="text-xs text-blue-700 font-medium mb-1">How it works:</p>
                <ul className="text-xs text-blue-600 space-y-1">
                  <li>• When {autoPromoMinQuantity}+ tickets are selected from the SAME category, {autoPromoDiscountPercentage}% discount applies automatically</li>
                  <li>• Discount only applies if no manual coupon code is used</li>
                  <li>• Different categories don't combine for the minimum quantity</li>
                  <li>• Removing manual coupon will re-enable auto discount if quantity qualifies</li>
                </ul>
              </div>
            </div>
          </div>

          {!userDetails?.type &&
            <>

              {/* Indian Pricing */}
              <div className="bg-gradient-to-r from-orange-50 via-amber-50 to-yellow-50 rounded-xl p-6 border border-orange-200/50">
                <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center space-x-2">
                  <div className="w-2 h-2 bg-orange-500 rounded-full"></div>
                  <span>Indian Pricing (₹)</span>
                </h3>

                {/* Add New Category Form */}
                <div className="grid grid-cols-2 md:grid-cols-7 gap-2 mb-4">
                  <input
                    type="text"
                    placeholder="Category Name"
                    value={currentIndianTicketName}
                    onChange={(e) => setCurrentIndianTicketName(e.target.value)}
                    className="h-8 px-2 border-2 border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 text-sm"
                  />
                  <input
                    type="number"
                    placeholder="Regular Price (₹)"
                    value={currentIndianTicketRegularPrice}
                    onChange={(e) => setCurrentIndianTicketRegularPrice(e.target.value)}
                    className="h-8 px-2 border-2 border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 text-sm"
                  />
                  <input
                    type="number"
                    placeholder="Early Bird (₹)"
                    value={currentIndianTicketEarlyBirdPrice}
                    onChange={(e) => setCurrentIndianTicketEarlyBirdPrice(e.target.value)}
                    className="h-8 px-2 border-2 border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 text-sm"
                  />
                  <input
                    type="number"
                    placeholder="Daily Rate (₹)"
                    value={currentIndianTicketEffectiveDailyRate}
                    onChange={(e) => setCurrentIndianTicketEffectiveDailyRate(e.target.value)}
                    className="h-8 px-2 border-2 border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-orange-500 text-sm"
                  />

                  {/* Background Image Upload */}
                  <div className="relative">
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) => handleIndianBgUpload(e.target.files[0])}
                      className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                      title="Add Background Image"
                    />
                    <div className="h-8 px-2 border-2 border-orange-300 rounded-md bg-orange-50 flex items-center justify-center text-xs text-orange-700 hover:bg-orange-100 cursor-pointer">
                      {currentIndianTicketBg ? '✓ BG' : '+ BG'}
                    </div>
                    {currentIndianTicketBg && (
                      <div className="absolute -bottom-8 left-0 z-10">
                        <img
                          src={currentIndianTicketBg}
                          alt="Preview"
                          className="w-12 h-8 object-cover rounded border border-orange-300"
                        />
                      </div>
                    )}
                  </div>

                  {/* Highlight Ticket Toggle */}
                  <div className="flex items-center justify-center bg-yellow-50 border border-yellow-200 rounded-md px-2">
                    <label className="inline-flex items-center cursor-pointer">
                      <input
                        type="checkbox"
                        checked={currentIndianTicketHighlight}
                        onChange={(e) => setCurrentIndianTicketHighlight(e.target.checked)}
                        className="h-3 w-3 text-yellow-600 border-gray-300 rounded focus:ring-yellow-500"
                      />
                      <span className="ml-1 text-xs text-yellow-700 font-medium">⭐ Highlight</span>
                    </label>
                  </div>

                  <button
                    onClick={addIndianTicketCategory}
                    className="px-3 py-1.5 bg-gradient-to-r from-orange-500 to-amber-600 text-white rounded-md hover:from-orange-400 hover:to-amber-500 transition-all duration-300 text-sm"
                  >
                    Add
                  </button>
                </div>

                {/* Existing Categories */}
                <div className="space-y-3">
                  {indianTicketCategories.map((tc, i) => renderIndianCategoryWithDates(tc, i))}
                </div>
              </div>

              {/* International Pricing */}
              <div className="bg-gradient-to-r from-blue-50 via-indigo-50 to-purple-50 rounded-xl p-6 border border-blue-200/50">
                <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center space-x-2">
                  <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                  <span>International Pricing ($)</span>
                </h3>

                {/* Add New Category Form */}
                <div className="grid grid-cols-2 md:grid-cols-7 gap-2 mb-4">
                  <input
                    type="text"
                    placeholder="Category Name"
                    value={currentInternationalTicketName}
                    onChange={(e) => setCurrentInternationalTicketName(e.target.value)}
                    className="h-8 px-2 border-2 border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                  />
                  <input
                    type="number"
                    placeholder="Regular Price ($)"
                    value={currentInternationalTicketRegularPrice}
                    onChange={(e) => setCurrentInternationalTicketRegularPrice(e.target.value)}
                    className="h-8 px-2 border-2 border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                  />
                  <input
                    type="number"
                    placeholder="Early Bird ($)"
                    value={currentInternationalTicketEarlyBirdPrice}
                    onChange={(e) => setCurrentInternationalTicketEarlyBirdPrice(e.target.value)}
                    className="h-8 px-2 border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                  />
                  <input
                    type="number"
                    placeholder="Daily Rate ($)"
                    value={currentInternationalTicketEffectiveDailyRate}
                    onChange={(e) => setCurrentInternationalTicketEffectiveDailyRate(e.target.value)}
                    className="h-8 px-2 border-2 border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                  />

                  {/* Background Image Upload */}
                  <div className="relative">
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) => handleInternationalBgUpload(e.target.files[0])}
                      className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                      title="Add Background Image"
                    />
                    <div className="h-8 px-2 border-2 border-blue-300 rounded-md bg-blue-50 flex items-center justify-center text-xs text-blue-700 hover:bg-blue-100 cursor-pointer">
                      {currentInternationalTicketBg ? '✓ BG' : '+ BG'}
                    </div>
                    {currentInternationalTicketBg && (
                      <div className="absolute -bottom-8 left-0 z-10">
                        <img
                          src={currentInternationalTicketBg}
                          alt="Preview"
                          className="w-12 h-8 object-cover rounded border border-blue-300"
                        />
                      </div>
                    )}
                  </div>

                  {/* Highlight Ticket Toggle */}
                  <div className="flex items-center justify-center bg-yellow-50 border border-yellow-200 rounded-md px-2">
                    <label className="inline-flex items-center cursor-pointer">
                      <input
                        type="checkbox"
                        checked={currentInternationalTicketHighlight}
                        onChange={(e) => setCurrentInternationalTicketHighlight(e.target.checked)}
                        className="h-3 w-3 text-yellow-600 border-gray-300 rounded focus:ring-yellow-500"
                      />
                      <span className="ml-1 text-xs text-yellow-700 font-medium">⭐ Highlight</span>
                    </label>
                  </div>

                  <button
                    onClick={addInternationalTicketCategory}
                    className="px-3 py-1.5 bg-gradient-to-r from-blue-500 to-indigo-600 text-white rounded-md hover:from-blue-400 hover:to-indigo-500 transition-all duration-300 text-sm"
                  >
                    Add
                  </button>
                </div>

                {/* Existing Categories */}
                <div className="space-y-3">
                  {internationalTicketCategories.map((tc, i) => renderInternationalCategoryWithDates(tc, i))}
                </div>
              </div>
            </>
          }


          {/* Coupons */}
          <div className="bg-gradient-to-r from-pink-50 via-rose-50 to-red-50 rounded-xl p-6 border border-pink-200/50">
            <h3 className="text-lg font-bold text-gray-800 mb-4 flex items-center space-x-2">
              <div className="w-2 h-2 bg-pink-500 rounded-full"></div>
              <span>Coupons</span>
            </h3>

            {/* Add New Coupon Form */}
            <div className="grid grid-cols-2 md:grid-cols-5 gap-2 mb-4">
              <input
                type="text"
                placeholder="Coupon Code"
                value={currentCouponName}
                onChange={(e) => setCurrentCouponName(e.target.value)}
                className="h-8 px-2 border-2 border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-pink-500 focus:border-pink-500 text-sm"
              />
              <input
                type="number"
                placeholder="Value"
                value={currentCouponValue}
                onChange={(e) => setCurrentCouponValue(e.target.value)}
                className="h-8 px-2 border-2 border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-pink-500 focus:border-pink-500 text-sm"
              />

              {/* NEW: Coupon Limit Field */}
              <input
                type="number"
                placeholder="Limit (empty = unlimited)"
                value={currentCouponLimit}
                onChange={(e) => setCurrentCouponLimit(e.target.value)}
                className="h-8 px-2 border-2 border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-pink-500 focus:border-pink-500 text-sm"
                min="1"
              />

              <select
                value={currentCouponType}
                onChange={(e) => setCurrentCouponType(e.target.value)}
                className="h-8 px-2 border-2 border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-pink-500 focus:border-pink-500 text-sm"
              >
                <option value="percentage">Percentage</option>
                <option value="fixed">Fixed Amount</option>
              </select>
              <select
                value={currentCouponScope}
                onChange={(e) => setCurrentCouponScope(e.target.value)}
                className="h-8 px-2 border-2 border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-pink-500 focus:border-pink-500 text-sm"
              >
                <option value="indian">Indian</option>
                <option value="international">International</option>
              </select>

              <select
                multiple
                value={currentCouponSelectedCategories}
                onChange={e => setCurrentCouponSelectedCategories(Array.from(e.target.selectedOptions, option => option.value))}
                className="h-20 px-2 border-2 border-gray-200 rounded-md focus:outline-none focus:ring-2 focus:ring-pink-500 focus:border-pink-500 text-sm"
                title="Hold Ctrl/Cmd to select multiple categories. Leave empty for all categories."
              >
                <option value="">All Categories (Default)</option>
                {/* Indian categories */}
                {indianTicketCategories.map(category => (
                  <option key={`indian-${category.name}`} value={category.name}>
                    Indian: {category.name}
                  </option>
                ))}
                {/* International categories */}
                {internationalTicketCategories.map(category => (
                  <option key={`international-${category.name}`} value={category.name}>
                    International: {category.name}
                  </option>
                ))}
              </select>

                {/* NEW: Apply from Regular Price Checkbox - Add to EditEvents state */}
    <div className="md:col-span-6 flex items-center bg-blue-50 border border-blue-200 rounded-md px-3 py-2">
        <label className="inline-flex items-center cursor-pointer">
            <input
                type="checkbox"
                checked={currentCouponApplyFromRegular}
                onChange={(e) => setCurrentCouponApplyFromRegular(e.target.checked)}
                className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
            />
            <span className="ml-2 text-sm text-blue-800 font-medium">
                Calculate discount from MRP/Regular Price (not Early Bird)
            </span>
        </label>
        {currentCouponApplyFromRegular && (
            <div className="ml-3 bg-blue-100 text-blue-800 px-2 py-1 rounded-full text-xs font-medium">
                MRP Discount
            </div>
        )}
    </div>
              <button
                onClick={addCoupon}
                className="px-3 py-1.5 bg-gradient-to-r from-pink-500 to-rose-600 text-white rounded-md hover:from-pink-400 hover:to-rose-500 transition-all duration-300 text-sm"
              >
                Add
              </button>
            </div>

            {/* Existing Coupons */}
            <div className="space-y-2">
              {coupons.map((coupon, index) => (
                <div key={index} className="flex items-center justify-between p-2 bg-white/50 border border-pink-200 rounded-lg">
                  <div className="flex items-center space-x-4 text-sm">
                    <span className="font-bold text-pink-700">{coupon.name}</span>
                    <span>{coupon.value}{coupon.type === 'percentage' ? '%' : (coupon.scope === 'indian' ? '₹' : '$')} off</span>
                    <span className="text-xs bg-pink-100 text-pink-700 px-2 py-1 rounded-full">{coupon.scope}</span>

                     <span className="text-xs bg-blue-100 text-blue-700 px-2 py-1 rounded-full">
                    {coupon.limit !== null 
                        ? `${coupon.usedCount || 0}/${coupon.limit} used` 
                        : 'Unlimited'}
                </span>
                  {/* NEW: Show if coupon applies from regular price */}
                {coupon.applyFromRegularPrice && (
                    <span className="text-xs bg-green-100 text-green-700 px-2 py-1 rounded-full font-medium">
                        MRP Discount
                    </span>
                )}
                    {/* NEW: Show selected categories */}
                    {coupon.selectedCategoryTickets && coupon.selectedCategoryTickets.length > 0 && (
                      <span className="text-xs bg-blue-100 text-blue-700 px-2 py-1 rounded-full">
                        Only: {coupon.selectedCategoryTickets.join(', ')}
                      </span>
                    )}
                  </div>
                  <div
                    onClick={() => removeCoupon(index)}
                    className="p-1 text-red-600 hover:text-red-800 cursor-pointer"
                  >
                    <Trash2 className="w-4 h-4" />
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Form Actions */}
          <div className="flex justify-end space-x-4 pt-6 border-t border-gray-200">
            <button
              type="button"
              onClick={onClose}
              className="px-6 py-3 border-2 border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors duration-200"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={isUpdating}
              className="px-6 py-3 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-lg hover:from-blue-600 hover:to-purple-700 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed flex items-center space-x-2"
            >
              {isUpdating ? (
                <>
                  <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                  <span>Saving...</span>
                </>
              ) : (
                <>
                  <Save className="w-4 h-4" />
                  <span>{newEvent ? "Create Event" : "Save Changes"}</span>
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditEvents;
